import { render, staticRenderFns } from "./checkoutV2.vue?vue&type=template&id=6dadac88&scoped=true"
import script from "./checkoutV2.vue?vue&type=script&lang=js"
export * from "./checkoutV2.vue?vue&type=script&lang=js"
import style0 from "./checkoutV2.vue?vue&type=style&index=0&id=6dadac88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dadac88",
  null
  
)

export default component.exports